// extracted by mini-css-extract-plugin
export default {"serviceSection":"serviceSection__YzVjN","image":"image__YzRlO","heading":"heading__Y2YyY"};